/* 
{
    id: ,
    preq_keywords: ,
    buttons: [
        {},
        {},
    ],
    question: ,
    extra_info: ,
},

*/
export default ({
    name: 'Questions',
    questions: [
        
    // Confirm suspected source of Problems

        // PWR ---> Check PWR LED
        
        {
            id: 0,
            preq_keywords: ['estimated_pwr', 'pwr_led', 'good_pwr_led'],
            buttons: [
                {text: 'pwr_confirmation_good_led_btn_1', add: ['pwr', 'little_power'], remove: [] },
                {text: 'pwr_confirmation_good_led_btn_2', add: ['pwr', 'no_power'], remove: [] },
                {text: 'pwr_confirmation_good_led_btn_3', add: ['maybe_pwr', 'estimated_sd'], remove: ['estimated_pwr'] },
                {text: 'pwr_confirmation_good_led_btn_4', add: ['estimated_sd'], remove: ['estimated_pwr'] } 
            ],
            question: 'pwr_confirmation_good_led',
            extra_info: 'pwr_confirmation_good_led_info',
        },

        {
            id: 21,
            preq_keywords: ['estimated_pwr', 'pwr_led', 'bad_pwr_led'],
            buttons: [
                {text: 'pwr_confirmation_bad_led_btn_1', add: ['pwr', 'little_power', 'no_power'], remove: [] },
                {text: 'pwr_confirmation_bad_led_btn_2', add: ['maybe_pwr', 'maybe_little_power', 'maybe_no_power', 'estimated_sd'], remove: ['estimated_pwr'] },
                {text: 'pwr_confirmation_bad_led_btn_3', add: ['estimated_sd', 'maybe_pwr', 'maybe_little_power'], remove: ['estimated_pwr'] } 
            ],
            question: 'pwr_confirmation_bad_led',
            extra_info: 'pwr_confirmation_bad_led_info',
        },

        // SD ---> Check ACT LED

        {
            id: 1,
            preq_keywords: ['estimated_sd'],
            buttons: [
                {text: 'sd_confirmation_btn_1', add: ['sd'], remove: [] },
                {text: 'sd_confirmation_btn_2', add: ['maybe_sd', 'estimated_video'], remove: ['estimated_sd'] },
                {text: 'sd_confirmation_btn_3', add: ['estimated_video'], remove: ['estimated_sd'] }, 
                {text: 'sd_confirmation_btn_4', add: ['sd', 'regular_act'], remove: [] },
            ],
            question: 'sd_confirmation',
            extra_info: 'sd_confirmation_info',
        },

        {
            id: 22,
            preq_keywords: ['estimated_pwr', 'no_pwr_led'],
            buttons: [
                {text: 'sd_confirmation_btn_1', add: ['pwr', 'little_power', 'no_power', 'maybe_sd'], remove: [] },
                {text: 'sd_confirmation_btn_2', add: ['maybe_sd', 'maybe_pwr', 'maybe_little_power', 'maybe_no_power', 'estimated_video'], remove: ['estimated_sd'] },
                {text: 'sd_confirmation_btn_3', add: ['estimated_video'], remove: ['estimated_sd'] },
                {text: 'sd_confirmation_btn_4', add: ['sd', 'regular_act'], remove: [] }, 
            ],
            question: 'sd_confirmation',
            extra_info: 'sd_confirmation_info',
        },


        // Video ---> Check if Video output


        // Internet --> Ethernet or WiFi

        {
            id: 25,
            preq_keywords: ['estimated_internet'],
            buttons: [
                {text: 'internet_confirmation_btn_1', add: ['ethernet'], remove: [] },
                {text: 'internet_confirmation_btn_2', add: ['wifi'], remove: [] }, 
            ],
            question: 'internet_confirmation',
            extra_info: 'internet_confirmation_info',
        },
        
    // PWR further specification

        // Unsuitable PSU?

        {
            id: 4,
            preq_keywords: ['pwr', 'little_power'],
            buttons: [
                {text: 'bad_psu_confirmation_btn_1', add: ['problem_unsuitable_psu'], remove: [] },
                {text: 'bad_psu_confirmation_btn_2', add: ['maybe_problem_unsuitable_psu'], remove: [] },
                {text: 'bad_psu_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'bad_psu_confirmation',
            extra_info: 'bad_psu_confirmation_info',
        },

        // Too much power draw over USB

        {
            id: 42,
            preq_keywords: ['pwr', 'little_power'],
            buttons: [
                {text: 'usb_power_draw_confirmation_btn_1', add: ['problem_too_much_usb_power_draw'], remove: [] },
                {text: 'usb_power_draw_confirmation_btn_2', add: ['maybe_problem_too_much_usb_power_draw'], remove: [] },
                {text: 'usb_power_draw_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'usb_power_draw_confirmation',
            extra_info: 'usb_power_draw_confirmation_info',
        },

        // Badly inserted cable?

        {
            id: 6,
            preq_keywords: ['pwr', 'no_power'],
            buttons: [
                {text: 'badly_inserted_cable_confirmation_btn_1', add: ['problem_badly_inserted_cable'], remove: [] },
                {text: 'badly_inserted_cable_confirmation_btn_2', add: ['maybe_problem_badly_inserted_cable'], remove: [] },
                {text: 'badly_inserted_cable_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'badly_inserted_cable_confirmation',
            extra_info: 'badly_inserted_cable_confirmation_info',
        },


        // Broken PSU?

        {
            id: 8,
            preq_keywords: ['pwr','no_power'],
            buttons: [
                {text: 'broken_psu_confirmation_btn_1', add: ['problem_defective_psu'], remove: [] },
                {text: 'broken_psu_confirmation_btn_2', add: ['maybe_problem_defective_psu'], remove: [] },
                {text: 'broken_psu_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'broken_psu_confirmation',
            extra_info: 'broken_psu_confirmation_info',
        },
    

    // SD further specification

        // Wrong OS?

        {
            id: 10,
            preq_keywords: ['sd'],
            buttons: [
                {text: 'wrong_os_confirmation_btn_1', add: ['problem_wrong_os'], remove: [] },
                {text: 'wrong_os_confirmation_btn_2', add: ['maybe_problem_wrong_os'], remove: [] },
                {text: 'wrong_os_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'wrong_os_confirmation',
            extra_info: 'wrong_os_confirmation_info',
        },

        // Obsolete OS?

        {
            id: 11,
            preq_keywords: ['sd'],
            buttons: [
                {text: 'obsolete_os_confirmation_btn_1', add: ['problem_obsolete_os'], remove: [] },
                {text: 'obsolete_os_confirmation_btn_2', add: ['maybe_problem_obsolete_os'], remove: [] },
                {text: 'obsolete_os_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'obsolete_os_confirmation',
            extra_info: 'obsolete_os_confirmation_info', 
        },

        // Wrong OS?

        {
            id: 23,
            preq_keywords: ['sd'],
            buttons: [
                {text: 'noobs_confirmation_btn_1', add: ['noobs'], remove: [] },
                {text: 'noobs_confirmation_btn_2', add: [], remove: [] }, 
            ],
            question: 'noobs_confirmation',
            extra_info: 'noobs_confirmation_info',
        },

        // Badly inserted SD card?

        {
            id: 12,
            preq_keywords: ['sd'],
            buttons: [
                {text: 'badly_inserted_sd_card_confirmation_btn_1', add: ['problem_badly_inserted_sd'], remove: [] },
                {text: 'badly_inserted_sd_card_confirmation_btn_2', add: ['maybe_problem_badly_inserted_sd'], remove: [] },
                {text: 'badly_inserted_sd_card_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'badly_inserted_sd_card_confirmation',
            extra_info: 'badly_inserted_sd_card_confirmation_info',
        },

        // Is the SD card formatted properly?

        {
            id: 14,
            preq_keywords: ['sd'],
            buttons: [
                {text: 'badly_formatted_sd_card_confirmation_btn_1', add: ['problem_badly_formatted_sd'], remove: [] },
                {text: 'badly_formatted_sd_card_confirmation_btn_2', add: ['maybe_problem_badly_formatted_sd'], remove: [] },
                {text: 'badly_formatted_sd_card_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'badly_formatted_sd_card_confirmation',
            extra_info: 'badly_formatted_sd_card_confirmation_info',
        },

        // Is the SD card broken or corrupted?

        
        {
            id: 13,
            preq_keywords: ['sd'],
            buttons: [
                {text: 'broken_sd_card_confirmation_btn_1', add: ['problem_defective_or_corrupted_sd'], remove: [] },
                {text: 'broken_sd_card_confirmation_btn_2', add: ['maybe_problem_defective_or_corrupted_sd'], remove: [] },
                {text: 'broken_sd_card_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'broken_sd_card_confirmation',
            extra_info: 'broken_sd_card_confirmation_info',
        },


    // Video further specification

        // HDMI connected to wrong port

        {
            id: 15,
            preq_keywords: ['video', 'no_output'],
            buttons: [
                {text: 'wrong_port_hdmi_cable_confirmation_btn_1', add: ['problem_wrong_port_hdmi'], remove: [] },
                {text: 'wrong_port_hdmi_cable_confirmation_btn_2', add: ['maybe_problem_wrong_port_hdmi'], remove: [] }, 
                {text: 'wrong_port_hdmi_cable_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'wrong_port_hdmi_cable_confirmation',
            extra_info: 'wrong_port_hdmi_cable_confirmation_info',
        },

        // HDMI cable connected correctly

        {
            id: 16,
            preq_keywords: ['video'],
            buttons: [
                {text: 'wrongly_connected_hdmi_cable_confirmation_btn_1', add: ['problem_badly_connected_hdmi'], remove: [] },
                {text: 'wrongly_connected_hdmi_cable_confirmation_btn_2', add: ['maybe_problem_badly_connected_hdmi'], remove: [] },
                {text: 'wrongly_connected_hdmi_cable_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'wrongly_connected_hdmi_cable_confirmation',
            extra_info: 'wrongly_connected_hdmi_cable_confirmation_info',
        },

        // Wrong video output selected (Only NOOBS)

        {
            id: 17,
            preq_keywords: ['video', 'noobs', 'no_output'],
            buttons: [
                {text: 'wrong_video_output_noobs_confirmation_btn_1', add: ['problem_wrong_video_output'], remove: [] },
                {text: 'wrong_video_output_noobs_confirmation_btn_2', add: ['maybe_problem_wrong_video_output'], remove: [] },
                {text: 'wrong_video_output_noobs_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'wrong_video_output_noobs_confirmation',
            extra_info: 'wrong_video_output_noobs_confirmation_info',
        },

        // Broken HDMI cable

        {
            id: 19,
            preq_keywords: ['video'],
            buttons: [
                {text: 'broken_hdmi_cable_confirmation_btn_1', add: ['problem_defective_hdmi'], remove: [] },
                {text: 'broken_hdmi_cable_confirmation_btn_2', add: ['maybe_defective_hdmi'], remove: [] },
                {text: 'broken_hdmi_cable_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'broken_hdmi_cable_confirmation',
            extra_info: 'broken_hdmi_cable_confirmation_info',
        },

        // Broken monitor

        {
            id: 20,
            preq_keywords: ['video'],
            buttons: [
                {text: 'broken_monitor_confirmation_btn_1', add: ['problem_defective_monitor'], remove: [] },
                {text: 'broken_monitor_confirmation_btn_2', add: ['maybe_problem_defective_monitor'], remove: [] },
                {text: 'broken_monitor_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'broken_monitor_confirmation',
            extra_info: 'broken_monitor_confirmation_info',
        },

        // Pi not detecting monitor

        {
            id: 18,
            preq_keywords: ['video', 'no_output'],
            buttons: [
                {text: 'not_detecting_monitor_confirmation_btn_1', add: ['problem_not_detecting_monitor'], remove: [] },
                {text: 'not_detecting_monitor_confirmation_btn_2', add: ['maybe_problem_not_detecting_monitor'], remove: [] },
                {text: 'not_detecting_monitor_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'not_detecting_monitor_confirmation',
            extra_info: 'not_detecting_monitor_confirmation_info',
        },

        // Screen out of range

        {
            id: 24,
            preq_keywords: ['video', 'no_output'],
            buttons: [
                {text: 'screen_out_of_range_confirmation_btn_1', add: ['problem_screen_out_of_range'], remove: [] },
                {text: 'screen_out_of_range_confirmation_btn_2', add: ['maybe_problem_screen_out_of_range'], remove: [] },
                {text: 'screen_out_of_range_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'screen_out_of_range_confirmation',
            extra_info: 'screen_out_of_range_confirmation_info'
        },

        // Too little power for screen

        /* {
            id: 31,
            preq_keywords: ['video', 'inconsistent_output'],
            buttons: [
                {text: 'screen_too_little_power_confirmation_btn_1', add: ['problem_screen_pwr'], remove: [] },
                {text: 'screen_too_little_power_confirmation_btn_2', add: ['maybe_problem_screen_pwr'], remove: [] },
                {text: 'screen_too_little_power_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'screen_too_little_power_confirmation',
            extra_info: 'screen_too_little_power_confirmation_info'
        }, */

    
    // Internet (Ethernet) further specification

        // Problem with router
    
        {
            id: 27,
            preq_keywords: ['ethernet'],
            buttons: [
                {text: 'router_problem_confirmation_btn_1', add: ['problem_router'], remove: [] },
                {text: 'router_problem_confirmation_btn_2', add: ['maybe_problem_router'], remove: [] },
                {text: 'router_problem_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'router_problem_confirmation',
            extra_info: 'router_problem_confirmation_info'
        },

        // Badly inserted ethernet cable
        
        {
            id: 28,
            preq_keywords: ['ethernet'],
            buttons: [
                {text: 'badly_inserted_ethernet_cable_confirmation_btn_1', add: ['problem_badly_inserted_ethernet_cable'], remove: [] },
                {text: 'badly_inserted_ethernet_cable_confirmation_btn_2', add: ['maybe_problem_badly_inserted_ethernet_cable'], remove: [] },
                {text: 'badly_inserted_ethernet_cable_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'badly_inserted_ethernet_cable_confirmation',
            extra_info: 'badly_inserted_ethernet_cable_confirmation_info'
        },
        
        // Defective ethernet cable
        
        {
            id: 26,
            preq_keywords: ['ethernet'],
            buttons: [
                {text: 'defective_ethernet_cable_confirmation_btn_1', add: ['problem_defective_ethernet_cable'], remove: [] },
                {text: 'defective_ethernet_cable_confirmation_btn_2', add: ['maybe_problem_defective_ethernet_cable'], remove: [] },
                {text: 'defective_ethernet_cable_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'defective_ethernet_cable_confirmation',
            extra_info: 'defective_ethernet_cable_confirmation_info'
        },


    //  Internet (WiFi) further specification
    
        // Logged in but no internet connection

        {
            id: 29,
            preq_keywords: ['wifi'],
            buttons: [
                {text: 'wifi_connection_but_no_internet_acess_confirmation_btn_1', add: ['wifi_connection_but_no_internet_access'], remove: [] },
                {text: 'wifi_connection_but_no_internet_acess_confirmation_btn_2', add: ['maybe_wifi_connection_but_no_internet_access'], remove: [] },
                {text: 'wifi_connection_but_no_internet_acess_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'wifi_connection_but_no_internet_acess_confirmation',
            extra_info: 'wifi_connection_but_no_internet_acess_confirmation_info'
        },

            // Can other devices connect to the Wifi?

            {
                id: 32,
                preq_keywords: ['wifi', 'wifi_connection_but_no_internet_access'],
                buttons: [
                    {text: 'other_devices_connected_to_wifi_confirmation_btn_1', add: ['problem_router'], remove: [] },
                    {text: 'other_devices_connected_to_wifi_confirmation_btn_2', add: ['maybe_problem_pi_internet'], remove: [] },
                    {text: 'other_devices_connected_to_wifi_confirmation_btn_3', add: ['problem_pi_internet'], remove: [] }, 
                ],
                question: 'other_devices_connected_to_wifi_confirmation',
                extra_info: 'other_devices_connected_to_wifi_confirmation_info'
            },

        // Not detecting local network

        {
            id: 30,
            preq_keywords: ['wifi'],
            buttons: [
                {text: 'not_detecting_local_network_confirmation_btn_1', add: ['not_detecting_local_network'], remove: [] },
                {text: 'not_detecting_local_network_confirmation_btn_2', add: ['maybe_not_detecting_local_network'], remove: [] },
                {text: 'not_detecting_local_network_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'not_detecting_local_network_confirmation',
            extra_info: 'not_detecting_local_network_confirmation_info'
        },

            // Can other devices connect to the local network?

            {
                id: 33,
                preq_keywords: ['wifi', 'not_detecting_local_network'],
                buttons: [
                    {text: 'other_devices_detect_wifi_confirmation_btn_1', add: ['problem_router'], remove: [] },
                    {text: 'other_devices_detect_wifi_confirmation_btn_2', add: ['maybe_problem_pi_internet'], remove: [] },
                    {text: 'other_devices_detect_wifi_confirmation_btn_3', add: ['problem_pi_internet'], remove: [] }, 
                ],
                question: 'other_devices_detect_wifi_confirmation',
                extra_info: 'other_devices_detect_wifi_confirmation_info'
            },
        
    
    // Random rebooting (Not power related)

        // Running out of memory 

        // Using watchdog

        {
            id: 34,
            preq_keywords: ['random_reboot'],
            buttons: [
                {text: 'using_watchdog_confirmation_btn_1', add: ['watchdog'], remove: [] },
                {text: 'using_watchdog_confirmation_btn_2', add: ['maybe_watchdog'], remove: [] },
                {text: 'using_watchdog_confirmation_btn_3', add: [''], remove: [] }, 
            ],
            question: 'using_watchdog_confirmation',
            extra_info: 'using_watchdog_confirmation_info',
        },

        // Watchdog Problem?

        {
            id: 35,
            preq_keywords: ['watchdog'],
            buttons: [
                {text: 'watchdog_problem_confirmation_btn_1', add: ['problem_watchdog'], remove: [] },
                {text: 'watchdog_problem_confirmation_btn_2', add: ['maybe_problem_watchdog'], remove: [] },
                {text: 'watchdog_problem_confirmation_btn_3', add: [''], remove: [] }, 
            ],
            question: 'watchdog_problem_confirmation',
            extra_info: 'watchdog_problem_confirmation_info',
        },

        // Only rebooting when under stress? --> Question: Does it reboot when idling?
        
        {
            id: 36,
            preq_keywords: ['random_reboot'],
            buttons: [
                {text: 'idling_reboot_confirmation_btn_1', add: ['pwr', 'little_power', 'maybe_no_power'], remove: [] },
                {text: 'idling_reboot_confirmation_btn_2', add: ['maybe_pwr', 'maybe_little_power', 'maybe_no_power'], remove: [] },
                {text: 'idling_reboot_confirmation_btn_3', add: ['maybe_pwr', 'maybe_no_power'], remove: [] }, 
            ],
            question: 'idling_reboot_confirmation',
            extra_info: 'idling_reboot_confirmation_info',
        },


    // USB Devices not working

        // Determine whether Device or Raspi is the Problem

        {
            id: 37,
            preq_keywords: ['usb_not_working'],
            buttons: [
                {text: 'usb_device_broken_confirmation_btn_1', add: ['problem_usb_device_broken'], remove: [] },
                {text: 'usb_device_broken_confirmation_btn_2', add: ['pi_usb_not_working', "maybe_problem_usb_device_broken"], remove: [] },
                {text: 'usb_device_broken_confirmation_btn_3', add: ['pi_usb_not_working'], remove: [] }, 
            ],
            question: 'usb_device_broken_confirmation',
            extra_info: 'usb_device_broken_confirmation_info',
        },

        // Check if device is being detected

        {
            id: 38,
            preq_keywords: ['pi_usb_not_working'],
            buttons: [
                {text: 'usb_device_detected_confirmation_btn_1', add: ['usb_device_detected'], remove: [] },
                {text: 'usb_device_detected_confirmation_btn_2', add: ['usb_device_detected', 'maybe_usb_device_not_detected'], remove: [] },
                {text: 'usb_device_detected_confirmation_btn_3', add: ['usb_device_not_detected', 'maybe_pwr', 'maybe_little_power'], remove: [] }, 
            ],
            question: 'usb_device_detected_confirmation',
            extra_info: 'usb_device_detected_confirmation_info',
        },


        // If device is not detected

            // Check if USB port on the Raspberry Pi is working --> try other ports

            {
                id: 39,
                preq_keywords: ['usb_device_not_detected'],
                buttons: [
                    {text: 'single_broken_usb_port_confirmation_btn_1', add: ['problem_single_broken_usb_port'], remove: [''] },
                    {text: 'single_broken_usb_port_confirmation_btn_2', add: ['maybe_problem_single_broken_usb_port'], remove: [''] },
                    {text: 'single_broken_usb_port_confirmation_btn_3', add: [], remove: [] }, 
                ],
                question: 'single_broken_usb_port_confirmation',
                extra_info: 'single_broken_usb_port_confirmation_info',
            },


        // If not detected make sure all drivers are installed 

        {
            id: 41,
            preq_keywords: ['usb_device_detected'],
            buttons: [
                {text: 'usb_device_drivers_installed_confirmation_btn_1', add: ['problem_usb_device_drivers_missing'], remove: [] },
                {text: 'usb_device_drivers_installed_confirmation_btn_2', add: ['maybe_problem_usb_device_drivers_missing'], remove: [] },
                {text: 'usb_device_drivers_installed_confirmation_btn_3', add: [], remove: [] }, 
            ],
            question: 'usb_device_drivers_installed_confirmation',
            extra_info: 'usb_device_drivers_installed_confirmation_info',
        },




    ],
})